<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
      </div>
      <div class="search">
        <a-form layout='inline'>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>上课校区</span>
              </template>
              <a-select allowClear showSearch placeholder="请选择校区" mode="multiple" :maxTagCount="1" :maxTagTextLength='5' :filterOption="filterOption" @change="handleChange" style="width: 220px;">
                <a-select-option v-for="(d, index) of studios" :key="index" :value="d['studio_id']">{{ d['filter_name'] }}</a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>课程科目</span>
              </template>
              <a-select allowClear placeholder="请选择课程科目" :filterOption="filterOption" @change="handleSubjectChange" style="width: 180px">
                <a-select-option v-for="(d, index) of classCategorys" :key="index" :value="d['course_cate_id']">{{ d['filter_name'] }}</a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>时间筛选</span>
              </template>
              <a-range-picker
                :ranges="rangesData"
                :value='rangesValue'
                :disabled-date="disabledDate" :allowClear="false"
                :default-value="[moment(paramsData.start_date,'YYYY-MM-DD'),moment(paramsData.end_date,'YYYY-MM-DD')]"  style="width: 240px"
                @change="(date, dateString)=>onChange(date, dateString,1)" />
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-button @click="toScreen" type="primary">筛选</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="dashboard bk-group">
      <statistics :count='counts' :col="6"/>
      <a-row class="mb16" :gutter="16">
          <a-col :lg="24" :xl="12">
            <absence :loading='loading'  :item ='absenceData'/>
          </a-col>
          <a-col :lg="24" :xl="12">
            <absenceCourse :loading='loadingC'  :item ='absenceCData'/>
          </a-col>
          <a-col :lg="24" :xl="24">
            <absenceSummate :loading='loadingS'  :item ='absenceSData'/>
          </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import ranges from "@/common/mixins/ranges";
import moment from 'moment'
import absence from './absence'
import absenceCourse from './absenceCourse'
import absenceSummate from './absenceSummate'
import statistics from '../xqypb/statistics'

export default {
  name: 'qjsjtj',
  components:{
    absence,
    absenceCourse,
    absenceSummate,
    statistics
  },
  data() {
    return {
      loading:false,
      loadingC:false,
      loadingS:false,
      absenceData:{},
      absenceCData:{},
      absenceSData:{},
      studios:[],
      counts:[],
      classCategorys:[],
      paramsData:{
        start_date:'',
        end_date:'',
        studio_id:'',
        course_cate_id:''
      },
    }
  },
  mixins: [ranges],
  created() {
    this.paramsData.start_date = moment().subtract('days',30).format('YYYY-MM-DD')
    this.paramsData.end_date = moment().subtract('days',0).format('YYYY-MM-DD')
    this.rangesValue = [moment(this.paramsData.start_date,'YYYY-MM-DD'),moment(this.paramsData.end_date,'YYYY-MM-DD')]
    this.getList();
    this.getStudio();
    this.getClassCategory();
  },

  methods: {
    moment,
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async getList(obj){
      this.getCount(obj)
      this.getAbsence(obj)
      this.getAbsenceCourse(obj)
      this.getAbsenceSummate(obj)
    },
    async getAbsence(obj){
      this.loading = true
      let res = await this.$store.dispatch('analysisAbsenceAction', obj)
      this.absenceData = res.data
      this.loading = false
    },
    async getAbsenceCourse(obj){
      this.loadingC = true
      let res = await this.$store.dispatch('analysisAbsenceCourseAction', obj)
      this.absenceCData = res.data
      this.loadingC = false
    },
    async getAbsenceSummate(obj){
      this.loadingS = true
      let res = await this.$store.dispatch('analysisAbsenceSummateAction', obj)
      this.absenceSData = res.data
      this.loadingS = false
    },
    async getStudio() {
      let res = await this.$store.dispatch('searchBelongStudioAction', {})
      this.studios = res.data
    },
    async getClassCategory() {
      let res = await this.$store.dispatch('searchCourseTypeAction', {})
      this.classCategorys = res.data
    },
    async getCount(obj){
      let res = await this.$store.dispatch('analysisClassesCountAction', obj)
      this.counts = res.data
    },
    handleChange(value){
      this.paramsData.studio_id = value;
    },
    handleSubjectChange(value){
      this.paramsData.course_cate_id = value;
    },
    toScreen(){
      let obj = {
        search:this.paramsData
      }
      this.getList(obj);
    }
  }
}
</script>
